import React from 'react';
import styled from 'styled-components';

import NotificationItem from './NotificationItem';
import { useNotification } from '../context/notificationContext';

const NotificationsContainer = styled.div`
  display: flex;
  flex-flow: column-reverse;
  position: fixed;
  top: 5rem;
  right: 0;
  z-index: 1000;
`;

export const Notifications = () => {
  const notificationContex = useNotification();
  const { notifications } = notificationContex;

  return (
    <NotificationsContainer>
      {notifications.map(notification => (
        <NotificationItem
          key={notification.id}
          id={notification.id}
          message={notification.message}
          type={notification.type}
        />
      ))}
    </NotificationsContainer>
  );
};

export default Notifications;
